import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;
import OperatorGetParamsDialogStatusOpenApiModel = OperatorApplicationApi.OperatorGetParamsDialogStatusOpenApiModel;

export default function getLastClientDialogStatus(userdata: OperatorApplicationClientOpenApiModel) {
    let site = OperatorAccountStore.sitesDictionary.value[userdata.siteId];
    let result: OperatorGetParamsDialogStatusOpenApiModel;
    if (site) {
        if (userdata.lastDialog) {
            let dialogStatusId = userdata.lastDialog.statusId;
            result = site.dialogStatusList.find(status => status.id == dialogStatusId);
            if (!result) {
                result = OperatorAccountStore.data.value.unknownDialogStatus
            }
        }
    }
    return result;
}